export default "__VITE_ASSET__0d4745da__"